import React from "react";
import "./TotalSum.scss";
import { useTranslation } from "react-i18next";
import formatPrice from "../../../helpers/formatPrice";

const TotalSum = (props) => {
  const { t } = useTranslation();

  const getSum = () =>
    Object.values(props.cart).reduce((sum, curr) => sum + curr.totalPrice, 0);

  return (
    <div className="total_sum">
      <h3>{t("cartPage.estimatedTotal")}</h3>
      <strong>{formatPrice(getSum())} €</strong>
    </div>
  );
};

export default TotalSum;